var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C8.225 17 8 17.225 8 17.5V19.5C8 19.775 8.225 20 8.5 20H23.5C23.775 20 24 19.775 24 19.5V17.5C24 17.225 23.775 17 23.5 17H8.5ZM2.5 16C1.119 16 0 17.119 0 18.5C0 19.881 1.119 21 2.5 21C3.881 21 5 19.881 5 18.5C5 17.119 3.881 16 2.5 16ZM8.5 9C8.225 9 8 9.225 8 9.5V11.5C8 11.775 8.225 12 8.5 12H23.5C23.775 12 24 11.775 24 11.5V9.5C24 9.225 23.775 9 23.5 9H8.5ZM2.5 8C1.119 8 0 9.119 0 10.5C0 11.881 1.119 13 2.5 13C3.881 13 5 11.881 5 10.5C5 9.119 3.881 8 2.5 8ZM8.5 1C8.225 1 8 1.225 8 1.5V3.5C8 3.775 8.225 4 8.5 4H23.5C23.775 4 24 3.775 24 3.5V1.5C24 1.225 23.775 1 23.5 1H8.5ZM2.5 0C1.119 0 0 1.119 0 2.5C0 3.881 1.119 5 2.5 5C3.881 5 5 3.881 5 2.5C5 1.119 3.881 0 2.5 0Z",
    fill: "#151515",
    className: "hc-icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.33ef68224d44c405d7bff70511f96f39.svg";
export { ForwardRef as ReactComponent };